import { CompanyLicenseDetailsOutputWithStatus } from './company-license-details-output-with-status.model';


export class CompanyLicenseSelectByIdOutput implements ICompanyLicenseSelectByIdOutput {
    status!: number;
    message!: string;
    data!: CompanyLicenseDetailsOutputWithStatus;

    constructor(data?: ICompanyLicenseSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? CompanyLicenseDetailsOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyLicenseSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyLicenseSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompanyLicenseSelectByIdOutput {
    status: number;
    message: string;
    data: CompanyLicenseDetailsOutputWithStatus;
}

